<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('cadastro-ramo-atividade-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'cadastro-ramo-atividade-create'}"
                    color="primary"
                >
                    Cadastrar ramo de atividade
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/cadastro/ramo-atividade/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>